import { Component, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import Glider from 'glider-js';

@Component
export class LightSlider extends ThemeComponent {

    init() {
        setTimeout(() => {
            this.classList.add('is-visible');
        }, 100);
        const mmBreakpoint = window.matchMedia(`(max-width: 1024px)`);
        if (mmBreakpoint.matches) {
            new Glider(this, {

                // `auto` allows automatic responsive
                // width calculations
                slidesToShow: 1,
                slidesToScroll: 1,

                // should have been named `itemMinWidth`
                // slides grow to fit the container viewport
                // ignored unless `slidesToShow` is set to `auto`
                itemWidth: undefined,

                // if true, slides wont be resized to fit viewport
                // requires `itemWidth` to be set
                // * this may cause fractional slides
                exactWidth: false,

                // speed aggravator - higher is slower
                duration: .5,

                // dot container element or selector
                dots: '.dots',

                // arrow container elements or selector
                arrows: {
                    prev: 'CSS Selector',
                    // may also pass element directly
                    next: document.querySelector('CSS Selector')
                },

                // allow mouse dragging
                draggable: true,
                // how much to scroll with each mouse delta
                dragVelocity: 3,

                // use any custom easing function
                // compatible with most easing plugins
                easing: function(x, t, b, c, d) {
                    return c*(t/=d)*t + b;
                },

                // event control
                scrollPropagate: false,
                eventPropagate: true,

                // Force centering slide after scroll event
                scrollLock: true,
                // how long to wait after scroll event before locking
                // if too low, it might interrupt normal scrolling
                scrollLockDelay: 50,

                // Force centering slide after resize event
                resizeLock: true
            });
        }
    }
}
